import {formatTimestampToDateTime, timestampToDate} from '../../../../../utils/dateTimeUtils';

export const NEAR_DUE_HOURS = 6;

/**
 * 业务时间格式化：统一委托给项目通用 `formatTimestampToDateTime`，
 * 接受 epoch seconds / epoch millis / ISO-8601 字符串，自动按当前时区格式化为 `YYYY-MM-DD HH:mm`。
 * 仅当值为空时返回 '-' 占位。
 */
export const formatTime = (value?: string | number | null): string => {
    if (value == null || value === '') return '-';
    return formatTimestampToDateTime(value);
};

export const isNearDue = (deadline?: string | number | null, hours: number = NEAR_DUE_HOURS): boolean => {
    if (deadline == null || deadline === '') return false;
    const diff = timestampToDate(deadline).getTime() - Date.now();
    return diff > 0 && diff < hours * 3600 * 1000;
};

export const isOverdue = (deadline?: string | number | null): boolean => {
    if (deadline == null || deadline === '') return false;
    return timestampToDate(deadline).getTime() <= Date.now();
};

export const matchKeyword = (
    item: {trackingNumber?: string},
    keyword: string,
): boolean => {
    const kw = keyword.trim().toLowerCase();
    if (!kw) return true;
    const tn = item.trackingNumber ? String(item.trackingNumber) : '';
    return tn.toLowerCase().includes(kw);
};

/**
 * 按扩展名判断附件 URL 是否为图片。
 * S3 预签名 URL 常带 query 参数（?X-Amz-...），先取 pathname 再判扩展名。
 *
 * mobile 一期附件回显仅支持图片：PC 端可上传视频/压缩包等非图片附件，
 * mobile 端遇到这类 URL 会渲染成破图，故回显前用本函数过滤，只保留图片。
 *
 * 扩展名集合覆盖 PC 端图片上传 `accept="image/*"` 可能产生的主流类型——
 * 除 PC detectKind 识别的 png/jpg/gif/webp/bmp 外，额外纳入 svg/heic/heif/tiff/avif/ico，
 * 避免 iPhone 默认 heic 等图片在手机端被误判为非图片而漏显示。
 */
export const isImageUrl = (url?: string | null): boolean => {
    if (!url) return false;
    let path = url;
    try {
        path = new URL(url).pathname;
    } catch {
        // 非合法 URL（理论上不会发生）时退化为对原串判断
        path = url;
    }
    return /\.(png|jpe?g|gif|webp|bmp|svg|heic|heif|tiff?|avif|ico)$/i.test(path);
};
